<div class="d-flex p-2">
    <div class="mr-auto">
        <b>{{title}}</b>
    </div>
    <div>
      <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>
</div>
<ngx-extended-pdf-viewer [src]="pdfSrc" (pagesLoaded)="loaded($event)" [showSpreadButton]="false" [showRotateButton]="false" [enablePrint]="false" [showPropertiesButton]="false" [contextMenuAllowed]="false"
    [showSidebarButton]="false" [showUnverifiedSignatures]="true" [showDownloadButton]="false" [showOpenFileButton]="false"
    [showPrintButton]="false" useBrowserLocale="true" height="80vh" ></ngx-extended-pdf-viewer>